import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/app/resume/components/ResumeInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/components/common/Header.tsx");
